export const Type_Slip = 1;
export const Type_T4 = 2;